import { render, staticRenderFns } from "./ReservationCreateOrEdit.vue?vue&type=template&id=6b964bf0&"
import script from "./ReservationCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ReservationCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports